import React from "react";
import { FaWhatsapp } from "react-icons/fa";
import { useTranslation } from "react-i18next";

const WhatsAppButton = () => {
  const { i18n } = useTranslation();

  const phoneNumber = "212673496838";

  const message =
    i18n.language === "ar"
      ? "مرحباً، أريد المزيد من المعلومات."
      : "Bonjour, je veux plus d'informations.";

  const url = `https://wa.me/${phoneNumber}?text=${encodeURIComponent(message)}`;

  const isRTL = i18n.language === "ar";

  return (
    <a
      href={url}
      target="_blank"
      rel="noopener noreferrer"
      style={{
        position: "fixed",
        bottom: "20px",
       left: "20px",
right: "auto",
        backgroundColor: "#25D366",
        color: "#fff",
        borderRadius: "50%",
        width: "60px",
        height: "60px",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        fontSize: "30px",
        zIndex: 1000,
        boxShadow: "0 4px 8px rgba(0,0,0,0.3)",
        cursor: "pointer"
      }}
    >
      <FaWhatsapp />
    </a>
  );
};

export default WhatsAppButton;
